import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Iterate } from '~/components/commons'
import { NotificationPageContext } from '..'
import QuestionCard from '../../Questions/QuestionCard'
import ReviewCard from '../../Reviews/ReviewCard'
import CustomerMediaList from './CustomerMediaList'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'

const NotificationModal = () => {
  const { modalData, closeModal = () => {}, isOpen } = React.useContext(
    NotificationPageContext
  )
  const getModalTitleByType = type => {
    switch (type) {
      case 'NEW_QUESTION' ||
        'UPDATED_ANSWER' ||
        'NEW_ANSWER' ||
        'UPDATED_ANSWER':
        return <FormattedMessage id="Question notification" />
      case 'NEW_REVIEW' || 'UPDATED_REVIEW':
        return <FormattedMessage id="Review notification" />
      case 'NEW_CUSTOMER_MEDIA':
        return <FormattedMessage id="Customer images notification" />
      default:
        break
    }
  }

  const isQuestion = React.useMemo(() => {
    return [
      'NEW_QUESTION',
      'UPDATED_QUESTION',
      'NEW_ANSWER',
      'UPDATED_ANSWER',
    ].includes(modalData?.type)
  }, [modalData.type])

  const isReview = React.useMemo(() => {
    return ['NEW_REVIEW', 'UPDATED_REVIEW'].includes(modalData?.type)
  }, [modalData.type])

  const isMedia = React.useMemo(() => {
    return modalData?.type === 'NEW_CUSTOMER_MEDIA'
  }, [modalData.type])

  return (
    <Modal isOpen={isOpen} toggle={closeModal} size="lg">
      <ModalHeader toggle={closeModal}>
        {getModalTitleByType(modalData.type)}
      </ModalHeader>
      <ModalBody>
        {_.isArray(modalData?.data) && isQuestion && (
          <Iterate
            data={modalData?.data}
            keyExtractor={(_, idx) => idx}
            render={props => (
              <QuestionCard
                {...props}
                clipboardLink={modalData?.clipboardLink}
                templates={[]}
              />
            )}
          />
        )}
        {_.isArray(modalData?.data) && isReview && (
          <Iterate
            data={modalData?.data}
            keyExtractor={(_, idx) => idx}
            render={props => (
              <ReviewCard
                {...props}
                clipboardLink={modalData?.clipboardLink}
                templates={[]}
              />
            )}
          />
        )}

        {_.isArray(modalData?.data) && isMedia && (
          <Iterate
            data={modalData?.data}
            keyExtractor={(_, idx) => idx}
            render={props => <CustomerMediaList {...props} />}
          />
        )}
      </ModalBody>
    </Modal>
  )
}

export default NotificationModal
